import checkout from "./form";

const {
  formField: {
    title,
    description,
    status,
    project,
    ticket,
    startDate,
    customerReferenceProject,
    endDate,
    EstimatedStartDate,
    EstimatedEndDate,
    EstimatedTime,
    ActualStartDate,
    requestedBy,
    requestedDate,
    ActualEndDate,
    ActualTime,
    ActualBillableTime,
    ActualNonBillableTime,
    externalReference,
    reporter,
    synced,
    area,
    priority,
    team,
    employee,
    task,
    allowCreateTimeEntry,
    billable,
    reportTimeEntryDescription
  },
} = checkout;

const initialValues = {
  [EstimatedEndDate.name]: null,
  [priority.name]:"",
  [EstimatedStartDate.name]: null,
  [EstimatedTime.name]: null,
  [ActualEndDate.name]: null,
  [ActualStartDate.name]: null,
  [ActualTime.name]: null,
  [ActualBillableTime.name]: "",
  [ActualNonBillableTime.name]: "",
  [title.name]: "",
  [externalReference.name]: "",
  [customerReferenceProject.name]: "",
  [description.name]: "",
  [status.name]: null,
  [requestedBy.name]: "",
  [requestedDate.name]: null,
  [project.name]: null,
  [ticket.name]: null,
  [startDate.name]: null,
  [endDate.name]: null,
  [synced.name]: false,
  [area.name]: null,
  [team.name]: null,  
  [employee.name]: null,

  [task.name]: null,
  [allowCreateTimeEntry.name]: true,
  [billable.name]: false,
  [reportTimeEntryDescription.name]:false
};

export default initialValues;